import React, { Component, useState } from "react";
import {
  Show,
  List,
  TabbedShowLayout,
  Tab,
  Datagrid,
  BooleanField,
  EditButton,
  TextField,
  ReferenceField,
  ReferenceManyField,
  DateField,
  TopToolbar,
  RefreshButton,
  ListButton,
  useRecordContext,
  useResourceContext,
  usePermissions,
} from "react-admin";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import { Scrollbars } from "react-custom-scrollbars";
import {
  getLocalStorageKey,
  CommonHeaderOption,
  RUN_TIME_API_ENDPOINT,
} from "../common/common";
import { useLocation } from "react-router-dom";
// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
  display: "block",
  width: 400,
  // overflow: 'hidden',
  textOverflow: "ellipsis",
  whiteSpace: "break-spaces",
};

const ShowActions = () => {
  const resource = useResourceContext();
  return (
    <TopToolbar>
      <RefreshButton />
      <ListButton basePath={resource} />
    </TopToolbar>
  );
};

const ShowTitle = () => {
  const record = useRecordContext();
  return record && <span>Bulk Message Details {record.name}</span>;
};

const BulkSendMessageShow = (props) => {
  const [loadingShow, setLoadingShow] = useState(false);
  const permissions = usePermissions();
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const bulkSmsMessageId = pathSplit[2];

  return (
    <Show
      actions={<ShowActions permissions={permissions} />}
      {...props}
      title={<ShowTitle />}
    >
      <TabbedShowLayout className="tab-scroll">
        <Tab
          label="Details"
          sort={{ field: "created_at", order: "DESC" }}
          contentClassName="scrollTab"
        >
          <TextField label="Purpose" source="purpose" allowEmpty />
          <TextField label="Message Progress" source="job_status" />
          <TextField label="Creator Name" source="admin_name" />
          <TextField label="Creator Email" source="admin_email" />
          <TextField
            label="Count of targeted retailers"
            source="targeted_businesses_count"
            allowEmpty
          />
          <TextField
            label="Count of retailers notified"
            source="notified_businesses_count"
            allowEmpty
          />
          <TextField
            label="Count of retailers who have read"
            source="notification_read_count"
            allowEmpty
          />
          <TextField
            label="Completion %"
            source="send_status_percent"
            allowEmpty
          />
          {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
          <DateField label="Created At" source="created_at" showTime />
        </Tab>
        <Tab label="Sold To List">
          <ReferenceManyField
            addLabel={false}
            reference="send_sms_bulk_sold_to_list"
            target="id"
            className="tab-pagination"
          >
            <List
              actions={false}
              filterDefaultValues={{ id: bulkSmsMessageId }}
              exporter={false}
            >
              <Datagrid className="tab-data-grid" bulkActionButtons={false}>
                {/* <TextField label="Name" source="name" /> */}
                <TextField label="Sold To ID" source="sap_code" />
                <TextField label="Sold To Name" source="name" />
                <TextField label="Sold To Phone" source="phone" />
                <ReferenceField
                  label="User name"
                  source="user_id"
                  reference="users"
                  link="show"
                  allowEmpty
                >
                  <TextField source="first_name" />
                </ReferenceField>
                <TextField
                  label="Description"
                  style={textFieldStyle}
                  source="sms_text"
                />
                <BooleanField label="SMS status" source="send_status" />
                <TextField label="SMS response" source="send_response" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default BulkSendMessageShow;
